import {Cliente, Parametro} from './../../../model/catalogo';
import {TipoEvento} from './../../../model/constantes';
import {Component, OnInit} from '@angular/core';
import {ModalService} from '../../../service/modal.service';
import {GlobalService} from '../../../service/global.service';
import {ConstantesApiService} from '../../../service/api/constantes.api';
import {DetalhamentoApiService} from '../../../service/api/detalhamento.api';
import {ActivatedRoute, Router} from '@angular/router';
import {FTA, Historico} from '../../../model/catalogo';
import {TipoEstado} from '../../../model/constantes';
import {CatalogoApiService} from '../../../service/api/catalogo.api';
import {JQueryStatic} from 'jquery';

declare var $: JQueryStatic;

@Component({
    selector: 'detalhe-fta-modal',
    templateUrl: './detalhe-fta-modal.component.html',
    styleUrls: ['./detalhe-fta-modal.component.css']
})

export class DetalheFtaModalComponent {

    constructor(
        private globalService: GlobalService,
        public modalService: ModalService,
        private constantesService: ConstantesApiService,
        private detalhamentoService: DetalhamentoApiService,
        private catalogoService: CatalogoApiService,
        private route: ActivatedRoute,
        private router: Router
    ) {
    }

    private sub: any;

    estados: Array<TipoEstado> = new Array<TipoEstado>();
    eventos: Array<TipoEvento> = new Array<TipoEvento>();
    mensagemErro: string = '';
    codigoFTA: number = 0;
    versaoFTA: number = 0;
    fta: FTA = new FTA();

    ngOnInit() {
        this.mensagemErro = '';

        this.constantesService.buscaTipoEstado(0)
            .subscribe(estados => this.estados = estados as Array<TipoEstado>);

        this.constantesService.buscaTipoEvento(0)
            .subscribe(eventos => this.eventos = eventos as Array<TipoEvento>);

        this.sub = this.route
            .queryParams
            .subscribe(params => {
                // Defaults to 0 if no query param provided.
                if (params['codigo'] != '') {
                    this.codigoFTA = params['codigo'];
                }
                if (params['versao'] != '') {
                    this.versaoFTA = params['versao'];
                }
                this.buscarDetalhesFTA();
            });
    }

    buscarDetalhesFTA() {
        this.globalService.loading = true;
        this.detalhamentoService.detalhaFta(this.codigoFTA, this.versaoFTA)
            .subscribe(resposta => {
                this.globalService.loading = false;
                this.fta = resposta as FTA;
                this.fta.historico = this.fta.historico.sort((a: Historico, b: Historico) => {
                    let adate = new Date(a.dataHora);
                    let bdate = new Date(b.dataHora);
                    return new Date(bdate).getTime() - new Date(adate).getTime();
                });
            });
    }

    getEstado(codigo: Number): string {
        let estado = this.estados.find(x => x.codigo == codigo);
        if (estado != null) {
            return estado.descricao;
        }
        return '-';
    }

    getTipoEvento(codigo: number): string {
        let evento = this.eventos.find(x => x.codigo == codigo);
        if (evento != null) {
            return evento.nome;
        }
        return '-';
    }

    getCliente(cliente: Cliente): string {

        if (cliente != null) {
            switch (cliente.codTipoCliente) {
                case 1: /* Usuário Aplicação */
                    return cliente.userAplicacao.nomeUserAplicacao;
                case 2: /* MCI */
                    return cliente.mci.nomeCliente;
                case 3: /* UOR */
                    return cliente.uor.codUor + ' - ' + cliente.uor.nomeDependencia;
            }
        } else {
            return '-';
        }
    }

    parametrosTransmissao(parmTransmissao: Array<Parametro>) {
        return parmTransmissao.filter(x => this.nomeParametro(x.parmNome) != '-');
    }

    nomeParametro(parm: string): string {
        switch (parm.toLowerCase()) {
            case 'arquivoorigem':
                return 'Arquivo Origem';
            case 'arquivoorigemregex':
                return 'Arquivo Origem';
            case 'arquivodestino':
                return 'Arquivo Destino';
            case 'blksize':
                return 'Block Size (BLKSIZE)';
            case 'recfm':
                return 'Record Format (RECFM)';
            case 'lrecl':
                return 'Record Length (LRECL)';
            case 'datatype_destino':
                return 'Tipo de Arquivo';
            case 'tipo':
                return 'Tipo';
            case 'mapaconversao':
                return 'Mapa de Conversão';
            case 'conteudoTrailer':
                return 'Conteúdo Trailer';
            case 'conteudoHeader':
                return 'Conteúdo Header';
            /* case "": return ""; */
            default:
                return parm;
        }
    }

    parametrosOperacao(parmOperacao: Array<Parametro>) {
        return parmOperacao.filter(x => x.parmNome != 'arquivoOrigem' && x.parmNome != 'arquivoDestino').sort();
    }

    formataData(dt): string {
        var data = new Date(dt);
        return data.toLocaleString();
    }

    editarFTA() {
        $('#modal').modal('hide');
        this.router.navigate(['/fluxo-cliente-interno-completo', this.codigoFTA, this.versaoFTA]);
    }

    copiarFTA() {
        $('#modal').modal('hide');
        this.router.navigate(['/fluxo-cliente-interno-completo', this.codigoFTA, this.versaoFTA, 'S']);
    }

    despacharFTA() {
        this.catalogoService.despacharArtefatoFta(this.codigoFTA, this.versaoFTA, 'fta', 'FTA despachado')
            .subscribe(resposta => {
                    this.modalService.exibirMensagem('Sucesso', 'Fluxo de Transmissão de Arquivo número <b>' + this.codigoFTA + '</b> despachado com sucesso!', 'Fechar');
                    this.modalService.incluirDadosGerados('despachoOk');
                },
                erro => {
                    this.globalService.loading = false;
                }
            );
    }

    desativarFTA() {
        this.catalogoService.ativaDesativaArtefatoFta(this.codigoFTA, this.versaoFTA, 'fta', 'inativa', 'FTA desativado')
            .subscribe(resposta => {
                    this.modalService.exibirMensagem('Sucesso', 'Fluxo de Transmissão de Arquivo número <b>' + this.codigoFTA + '</b> desativado com sucesso!', 'Fechar');
                    //this.modalService.incluirDadosGerados("despachoOk");
                },
                erro => {
                    alert('Erro ao desativar o FTA');
                    // this.modalService.exibirMensagem("Erro", "Erro ao desativar o FTA" , "Fechar");
                    this.globalService.loading = false;
                }
            );
    }

    excluirFTA() {
        this.catalogoService.deletaArtefatoFta(this.codigoFTA, this.versaoFTA, 'fta', 'FTA excluído.')
            .subscribe(resposta => {
                    this.modalService.exibirMensagem('Sucesso', 'Fluxo de Transmissão de Arquivo número <b>' + this.codigoFTA + '</b> excluído com sucesso!', 'Fechar');
                    this.modalService.incluirDadosGerados('exclusaoOk');
                },
                erro => {
                    this.globalService.loading = false;
                }
            );
    }

    cancelar() {
        this.modalService.fecharPaginaModal();
    }

}



// WEBPACK FOOTER //
// ./src/app/modal/detalhe-fta-modal/detalhe-fta-modal.component.ts